import React, { useState, useEffect } from 'react';
import './style.css';
import whatsappIcon from '../../assets/icons/w-icon-hover.png';
const TopBands = () => {
  return (
    <div className='top-bands'>
      <div className='container-fluid top-bands1'>
        <div className='container top-bands1-txt'>
          Contact Us &nbsp;
          <a
            href='https://wa.me/+918169860012'
            target='_blank'
            rel='noreferrer'
          >
            <img
              src={whatsappIcon}
              id='wa-hover'
              width={20}
              alt='Whatsapp Icon'
              title='Whatsapp Icon'
            ></img>
            {'  '}
            +91 81698 60012
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBands;
